import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { fplConstantSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const fplConstantsContract = c.router({
  getFplConstantsByYear: {
    summary: "Get FPL constants by year",
    method: "GET",
    path: "/fpl-constants/:year",
    pathParams: z.object({
      year: z.coerce.number(),
    }),
    responses: {
      [HTTPStatusCode.OK]: fplConstantSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
